var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.955322H513V342.948H0V0.955322Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.5 0.955322H513V342.959H256.5V0.955322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.981 149.751L354.117 192.264C349.054 199.93 349.081 210.26 354.935 218.006C362.364 227.833 376.351 229.777 386.178 222.35C396.004 214.921 397.949 200.934 390.521 191.107C384.666 183.361 374.734 180.518 365.978 183.297L315.892 117.039L304.031 126.005L286.237 139.455L304.171 163.179L321.981 149.751ZM368.246 198.627C369.025 198.038 369.912 197.608 370.857 197.362C371.802 197.116 372.787 197.059 373.754 197.193C374.721 197.328 375.652 197.651 376.494 198.146C377.336 198.64 378.073 199.296 378.662 200.074C379.25 200.853 379.68 201.741 379.926 202.686C380.172 203.631 380.229 204.615 380.095 205.582C379.96 206.549 379.637 207.48 379.142 208.322C378.648 209.164 377.993 209.901 377.214 210.49C375.641 211.679 373.659 212.194 371.706 211.923C369.753 211.651 367.988 210.615 366.798 209.042C365.609 207.469 365.094 205.488 365.365 203.534C365.637 201.581 366.673 199.816 368.246 198.627Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.102 163.18L395.036 139.457L377.243 126.007L365.382 117.041L315.296 183.299C306.539 180.518 296.609 183.362 290.753 191.109C283.325 200.936 285.269 214.923 295.096 222.352C304.923 229.78 318.91 227.835 326.339 218.008C332.195 210.262 332.221 199.932 327.157 192.266L359.293 149.753L377.102 163.18ZM314.476 209.041C313.287 210.614 311.522 211.65 309.569 211.922C307.615 212.193 305.634 211.678 304.061 210.489C302.488 209.3 301.452 207.534 301.18 205.581C300.909 203.628 301.424 201.647 302.613 200.073C303.202 199.294 303.939 198.639 304.781 198.145C305.623 197.65 306.554 197.327 307.521 197.192C308.488 197.058 309.472 197.115 310.417 197.361C311.362 197.607 312.25 198.037 313.029 198.626C313.808 199.214 314.463 199.951 314.957 200.793C315.451 201.635 315.775 202.566 315.91 203.533C316.044 204.5 315.987 205.485 315.741 206.43C315.495 207.375 315.065 208.262 314.476 209.041Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.957275)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVa);
export default __webpack_public_path__ + "static/media/VA.e9a33de46a977aaa15f5e4db49916ebe.svg";
export { ForwardRef as ReactComponent };